import { ReactNode } from "react";

type OnConditionProps = {
    condition: boolean;
    children: ReactNode;
}

export const OnCondition = ({ condition, children }: OnConditionProps) => {
    return (
        <>
            {condition ? children : ""}
        </>
    );
}
